@charset "UTF-8";

/* src/app/components/news-popup/news-popup.component.scss */
.news-popup-wrapper {
  position: fixed;
  inset: 0;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
}
.news-popup-wrapper.open {
  opacity: 1;
  pointer-events: all;
}
.news-popup-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(1.5px);
  backdrop-filter: blur(1.5px);
}
.news-popup-container {
  position: relative;
  z-index: 2;
  width: 88%;
  max-width: 370px;
  max-height: 90vh;
  overflow-y: auto;
  background: var(--ion-color-light);
  border-radius: 20px;
  padding: 1.8rem 1.3rem 1.4rem;
  padding-top: 3rem;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(255, 255, 255, 0.12);
  transform: translateY(20px);
  opacity: 0;
  transition: opacity 0.28s ease, transform 0.28s ease;
}
.news-popup-wrapper.open .news-popup-container {
  transform: translateY(0);
  opacity: 1;
}
.news-popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(var(--ion-color-primary-rgb), 0.06);
  -webkit-backdrop-filter: blur(0px);
  backdrop-filter: blur(0px);
  border-radius: 50%;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.25);
  cursor: pointer;
  transition: 0.25s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15), inset 0 0 0 1px rgba(255, 255, 255, 0.08);
}
.news-popup-close ion-icon {
  font-size: 1.35rem;
  color: var(--ion-color-primary);
  transition: 0.25s ease;
}
.news-popup-close:hover {
  transform: scale(1.12) translateY(-1px);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  box-shadow: 0 6px 18px rgba(var(--ion-color-primary-rgb), 0.25), inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
.news-popup-close:hover ion-icon {
  color: var(--ion-color-primary);
}
.news-popup-close:active {
  transform: scale(0.94);
}
.news-popup-content {
  font-size: 1rem;
  line-height: 1.45;
  color: var(--ion-color-text);
}
.news-dynamic-body .news-title {
  margin: 0 0 0.5rem;
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--ion-color-text, #222428);
  line-height: 1.3;
  padding-right: 2.5rem;
}
.news-dynamic-body .news-message {
  margin: 0 0 1.5rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--ion-color-medium-shade, #6c6c6e);
}
.news-dynamic-body .news-generic-image {
  display: block;
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 1rem;
  margin-top: 1rem;
  background: var(--ion-color-light-shade, #f0f0f0);
}
.news-dynamic-body .news-actions {
  display: flex;
  justify-content: center;
  padding-top: 0.25rem;
}
.news-dynamic-body .news-primary-btn {
  min-width: 120px;
  padding: 0.55rem 1.4rem;
  border-radius: 999px;
  border: none;
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(var(--ion-color-primary-rgb), 0.35);
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    background 0.18s ease;
}
.news-dynamic-body .news-primary-btn:hover {
  background: var(--ion-color-primary-tint);
  box-shadow: 0 8px 22px rgba(var(--ion-color-primary-rgb), 0.45);
}
.news-dynamic-body .news-primary-btn:active {
  transform: scale(0.97);
  box-shadow: 0 3px 10px rgba(var(--ion-color-primary-rgb), 0.35);
}
/*# sourceMappingURL=news-popup.component.css.map */
